import { render } from "./QuestionFourScreen.vue?vue&type=template&id=7cea1e93&scoped=true&lang=html"
import script from "./QuestionFourScreen.vue?vue&type=script&lang=js"
export * from "./QuestionFourScreen.vue?vue&type=script&lang=js"

import "./QuestionFourScreen.vue?vue&type=style&index=0&id=7cea1e93&lang=scss&scoped=true"

import exportComponent from "/Users/peterdevos/Apps/clawmachine_rodi/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cea1e93"]])

export default __exports__